import * as Sentry from '@sentry/react';

export const SentryUserContext = {
  /**
   * Set user context in Sentry
   */
  setUser(user: { id: string; email: string }) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
    });
  },

  /**
   * Clear user context in Sentry
   */
  clearUser() {
    Sentry.setUser(null);
  },
};
